import { render, staticRenderFns } from "./UserCalendar.vue?vue&type=template&id=5097bc6e"
import script from "./UserCalendar.vue?vue&type=script&lang=js"
export * from "./UserCalendar.vue?vue&type=script&lang=js"
import style0 from "./UserCalendar.vue?vue&type=style&index=0&id=5097bc6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports